module.exports = __webpack_public_path__ + "img/p2-p1-bg.92c40c2e.jpg";